<script>
import { countLandingPageDayLog } from '@/services/api/statAPi'

export default {
  name: 'iOSAppDownload',
  created() {
    const flag = localStorage.getItem('attempt_to_jiahk_ios')
    if (flag === 'true') {
      countLandingPageDayLog({ event: 1 }).finally((res) => {
        window.location.href = 'https://apps.apple.com/cn/app/id1635507522'
        localStorage.removeItem('attempt_to_jiahk_ios')
      })
    } else {
      window.location.href = 'https://apps.apple.com/cn/app/id1635507522'
    }
  }
}
</script>

<template>
  <div></div>
</template>

<style scoped lang="less"></style>
